import ErrorBoundaryRoutes from "app/shared/error/error-boundary-routes";
import { Route } from "react-router-dom";
import { IRootState } from "app/config/store";
import { connect } from "react-redux";
import CurrentRegulations from "app/edozvola/current-regulations/current-regulations";
import React from "react";

const CurrentRegulationsRoutes = () => {
  return (
    <ErrorBoundaryRoutes>
      <Route index element={ <CurrentRegulations />}></Route>
    </ErrorBoundaryRoutes>
  );
}

const mapStateToProps = ({}: IRootState) => ( {} );
export default connect(mapStateToProps, null)(CurrentRegulationsRoutes);
